import { render, staticRenderFns } from "./ActionsColumn.vue?vue&type=template&id=03bf1e2c&"
import script from "./ActionsColumn.vue?vue&type=script&lang=js&"
export * from "./ActionsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports